import { styled } from "styled-components";
import theme from "../../styles/theme";
import { useEffect, useState } from "react";
import { sampleData } from "./SampleData";
import moment from "moment";
import EventNoteIcon from '@mui/icons-material/EventNote';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useGetProjectSchedule } from "../../interfaces/dashboard";

const MainWrap = styled.div`
    height: 100%;
    width: 100%;
    background: ${theme.color.white[100]};
    border-radius: 12px;
    padding: 0.5rem 1rem;
    .title_line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
            font-size: 1.25rem;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 8px;
        }
    }
`;

const TitleLine = styled.ul`
    list-style-type: none;
    padding:0;
    margin:0;
    li {
        // line-height: 2rem;
        // font-size: 2rem;
        display: grid;
        grid-template-columns: 5rem minmax(1rem,auto) 4rem 5rem 4rem 9.5rem 4rem;
        gap:0;
        div {
            margin: 3px 0;
            font-size: 1.2rem;
            text-align: center;
        }
        div:nth-child(2){
            text-align: left !important;
            padding-left: 8px;
            // border: 1px solid red;
        }
    }
    li:first-child {
        // font-size: 1rem;
        div {
            // margin: 0px 4px;
            display: block;
            text-align: center;
        }
        border-bottom:1px solid ${theme.color.black[20]};
    }
`; 

const DescArea = styled.ul`
    list-style-type: none;
    padding:0;
    margin:0;
    li {
        line-height: 2rem;
        font-size: 1.2rem;
        height: 3.25rem;
        display: grid;
        grid-template-columns: 5rem minmax(1rem,auto) 4rem 5rem 4rem 9.5rem 4rem;
        gap:0;
        div {
            // margin: 3px 0;
            text-align: center;
        }
        div:nth-child(2){
            text-align: left !important;
            padding-left: 8px;
        }
        .align {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .title_line {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 8px;
            .guide {
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 12px;
                padding: 0.6rem 0px;
                height: 0.8rem;
                min-width: 3rem;
                font-size: 0.6rem;
                line-height: 0.8rem;
                span:nth-child(2) {
                    color: red;
                    font-weight: bold;
                }
            }
            .titleEl {
                // width: 40%;
                // display: block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        div:nth-child(n+4){
            display: flex;
            justify-content: center;
            align-items: center;
            span {
                border-radius: 12px;
                padding: 0px 8px;
                // width: 70%;
            }
        }
    }
    li:nth-child(even){
        background: rgba(0, 0, 0, 0.04);
        border-radius: 12px;
    }
`;

const SetSchedules = () => {

    const [list, setList] = useState(sampleData);
    const {data} = useGetProjectSchedule();

    // useEffect(()=>{
    //     if(data){
    //         data.map((item,index)=>{
    //             const temp = item.inst_nm_list !== null ? item.inst_nm_list.replaceAll(',','') : '';
    //             return {
    //                 ...item,
    //                 set_person: temp !== '' ? item.inst_nm_list.split(',') : []
    //             }
    //         })
    //         setList(data);
    //     }
    // },[data])

    return (
        <MainWrap>
            <div className="title_line"><span><EventNoteIcon />담당자별 일정</span><MoreVertIcon /></div>
            <TitleLine>
                <li>
                    <div>담당자</div>
                    <div>과업명</div>
                    <div>지점수</div>
                    <div>촬영시간</div>
                    <div>설치일</div>
                    <div>촬영기간</div>
                    <div>철수일</div>
                </li>
            </TitleLine>
            <DescArea>
                {list && list.map((item,index)=>
                    {
                        return (
                            <li key={index}>
                                <div className="align">
                                    {item.set_person && item.set_person[0]}
                                </div>
                                <div className="title_line">
                                    <div className="titleEl">{item.title}</div>
                                </div>
                                <div className="align">{item.point_cnt}</div>
                                <div><span style={{background: theme.color.setting}}>{item.rec_timeH && parseInt(item.rec_timeH,10)}H</span></div>
                                <div><span style={{background: theme.color.setting}}>{item.set_from && moment(item.set_from).format('MM/DD')}</span></div>
                                <div><span style={{background: theme.color.coding}}>{item.rec_from && moment(item.rec_from).format('MM/DD')} - {item.rec_to && moment(item.rec_to).format('MM/DD')}</span></div>
                                <div><span style={{background: theme.color.complete}}>{item.set_to && moment(item.set_to).format('MM/DD')}</span></div>
                            </li>
                        )
                    }
                )}
            </DescArea>
        </MainWrap>
    )
}

export default SetSchedules;